import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { PartnerDto, SchoolBillDto, SchoolLevel, SchoolSubPayDto, SchoolSubsClassDto, SchoolSubscTransportDto, SchoolSubsItemValue } from '../../api/models';
import { SchoolSubscriptionPaymentCtlService } from '../../api/services';
import { SessionService } from '../../common/session.service';

import * as bootstrap from 'bootstrap';
import { constants, PaymentNetwork } from '../../common/constants';
import { environment } from '../../../environments/environment';
import { Router } from '@angular/router';

@Component({
  selector: 'app-cashier-school-subscription-payment',
  imports: [ReactiveFormsModule],
  templateUrl: './school-subscription-payment.component.html',
  styleUrl: './school-subscription-payment.component.css'
})
export class SchoolSubscriptionPaymentComponent implements OnInit {

  studentForm: FormGroup;
  payForm: FormGroup;
  phoneForm: FormGroup;
  connectedSchool?: PartnerDto;
  message = '';
  classes: Array<SchoolSubsClassDto> = Array.of();
  levels: Array<SchoolLevel> = Array.of();
  selectedClasses: Array<SchoolSubsClassDto> = Array.of();
  requiredItems: Array<SchoolSubsItemValue> = Array.of();
  nonRequiredItems: Array<SchoolSubsItemValue> = Array.of();
  selectedItems: Array<SchoolSubsItemValue> = Array.of();
  reliquat?: SchoolBillDto;
  transports: Array<SchoolSubscTransportDto> = Array.of();
  currentClass?: SchoolSubsClassDto;
  currentTransport?: SchoolSubscTransportDto;
  totalAmount = 0;
  transportSubsScription = false;
  paymentNetwork?: PaymentNetwork;
  idSchool: number = 0;
  idStudent: string = '';
  fees: number = 0;
  currentIdTransport: number = 0;
  idempotencyKey: string = '';
  processing = false;
  paymentMeans: PaymentNetwork[] = [];

  constructor(
    private schoolSubscripService: SchoolSubscriptionPaymentCtlService,
    private sessionService: SessionService,
    private formBuilder: FormBuilder,
    private route: Router
  ) {
    this.studentForm = this.formBuilder.group(
      {
        idStudent: ['', Validators.required]
      }
    );
    this.payForm = this.formBuilder.group(
      {
        idLevel: ['', [Validators.required, Validators.min(1)]],
        idReliquat: ['', Validators.required],
        idTransport: ['', Validators.required],
        idClass: ['', Validators.required],
      }
    );
    this.phoneForm = this.formBuilder.group({
      'phone': ['', Validators.required],
      'network': ['', Validators.required]
    });
     this.paymentMeans= constants.getPaymentNetworks(environment.codeCountry, 'cashier');
  }

  ngOnInit(): void {
    const sess = this.sessionService.getSessionInfo();
      this.connectedSchool = sess.partner;
      this.idSchool = sess.partner?.id!!;
    
  }

  findSubscriptionSubscriptionInfo() {
    if (!this.idSchool) {
      this.message = "Aucun établissement associé à votre compte";
      const modAdd = new bootstrap.Modal('#errorDialog', {});
      modAdd.show();
      return;
    }
    let form = this.studentForm.value;

    this.schoolSubscripService.subscriptionInfo1(
      this.idSchool,
       form.idStudent
    ).subscribe(
      {
        next: (resp) => {
          this.classes = resp.classes!!;
          this.levels = [];
          this.classes.forEach(cls => {
            let fi = this.levels.find(lev => lev.id == cls.classe.level!!.id);
            if (!fi) {
              this.levels.push(cls.classe.level!!);
            }
          });

          this.idStudent = form.idStudent;
          this.transports = resp.transports!!;
          this.reliquat = resp.reliquat;
          this.currentClass = undefined;
          this.currentTransport = undefined;
          this.payForm.controls['idReliquat'].setValue(this.reliquat?.id);

          this.calculateTotalAmount();
        },
        error: (err) => {
          this.message = err.error.message;
          const modAdd = new bootstrap.Modal('#errorDialog', {});
          modAdd.show();
        }
      }
    )
  }

  onChangeClass() {
    let idClass = this.payForm.value.idClass;
    if (idClass.length > 0) {
      this.currentClass = this.classes.find(x => x.classe.id == idClass)!!;
      this.requiredItems = [];
      this.selectedItems = [];
      this.nonRequiredItems = [];
      this.requiredItems = this.currentClass.otherItems?.filter(it => it.mandatory == true)!!;
      this.nonRequiredItems = this.currentClass.otherItems?.filter(it => it.mandatory == false)!!;
    } else {
      this.currentClass = undefined;
      this.currentTransport = undefined;
    }
    this.payForm.controls['idTransport'].setValue('0');
    this.calculateTotalAmount();
  }

  onChangeLevel() {
    let idLevel = this.payForm.value.idLevel;
    if (idLevel.length > 0) {
      this.selectedClasses = [];
      this.classes.forEach(cls => {
        if (cls.classe.level?.id == idLevel) {
          this.selectedClasses.push(cls);
        }
      })
    }
  }

  onSelectTransport() {
    let idTransport = Number(this.payForm.value.idTransport);
    console.log("selected transport " + idTransport);
    this.currentIdTransport = idTransport;
    if (idTransport > 0) {
      console.log("transports " + JSON.stringify(this.transports));
      this.currentTransport = this.transports.find(x => x.id === idTransport);
      console.log("current transport " + JSON.stringify(this.currentTransport));
    } else {
      this.currentTransport = undefined;
    }
    this.calculateTotalAmount();
  }

  onSubscription() {
    this.paymentNetwork = undefined;
    if (this.transportSubsScription === true && this.currentTransport==undefined) {
      this.message = "Veuillez sélectionner un itinéraire ou décocher la case d'abonnement au transport";
      const modAdd = new bootstrap.Modal('#errorDialog', {});
      modAdd.show();
      return;
    }else {
    const modAdd = new bootstrap.Modal('#payDialog', {});
    modAdd.show();
    }
  }

  calculateTotalAmount() {
    let amount = this.reliquat!!.amount!!;

    if (this.currentClass != undefined) {
      amount = amount + this.currentClass.apecAmount + this.currentClass.yearlyFee;
      amount = amount + this.currentClass.firstMonthAmount;
    }
    if (this.selectedItems.length > 0) {
      let itemsAmount = 0;
      this.selectedItems.forEach(function (item) {
        itemsAmount = itemsAmount + item.value!!;
      });
      amount = amount + itemsAmount;
    }
    if (this.requiredItems.length > 0) {
      let itemsAmount = 0;
      this.requiredItems.forEach(function (item) {
        itemsAmount = itemsAmount + item.value!!;
      });
      amount = amount + itemsAmount;
    }
    if (this.currentTransport != undefined) {
      amount = amount + this.currentTransport.monthlyAmount + this.currentTransport.subscription;
    }

    this.totalAmount = amount;
  }

  onTransportChange() {
    this.transportSubsScription = !this.transportSubsScription;
    if (!this.transportSubsScription) {
      this.payForm.controls['idTransport'].updateValueAndValidity();
      this.payForm.controls['idTransport'].setValue(0);
    }
    this.calculateTotalAmount()
  }

  onPaySubscription() {
    let networkOption = '';
    this.processing = true;
    if (this.paymentNetwork?.code.toUpperCase() == 'OMSN') {
      networkOption = 'maxit';
    }
    let payDto: SchoolSubPayDto = {
      idReliquat: this.reliquat?.id!!,
      idStudent: this.idStudent,
      idSubscriptionClass: this.currentClass?.id!!,
      parentName: this.reliquat?.parentFirstName + ' ' + this.reliquat?.parentLastName,
      studentName: this.reliquat?.studentName!!,
      idTransport: this.currentIdTransport,
      paymentMethod: this.paymentNetwork?.mode,
      paymentNetwork: this.paymentNetwork?.code,
      paymentNetworkOption: networkOption,
      items: this.selectedItems
    };
    this.schoolSubscripService.subscriptionPayment1(
       payDto
    ).subscribe({
      next: (resp) => {
        this.processing = false;
        if(resp.status == 'PENDING') {
        if (resp.paymentUrl) {
          window.open(resp.paymentUrl, '_blank');
        } else {
          this.message = "Paiement echoué veuillez réessayer";
          const modAdd = new bootstrap.Modal('#errorDialog', {});
          modAdd.show();
        }
      } else {
        this.route.navigateByUrl('/cashier/receipt/' + resp.reference);
      }
      },
      error: (err) => {
        this.processing = false;
        this.message = err.error.message;
        const modAdd = new bootstrap.Modal('#errorDialog', {});
        modAdd.show();
      }
    })
  }

  onCancelSubscription() {
    this.payForm.reset();
    this.currentClass = undefined;
    this.currentTransport = undefined;
    this.totalAmount = 0;
    this.levels = Array.of();
    this.classes = Array.of();
    this.transports = Array.of();
    this.reliquat = undefined;
    this.paymentNetwork = undefined;
  }

  onSelectPaymentMethod(network: PaymentNetwork) {
    this.paymentNetwork = network;

    this.phoneForm.patchValue({network: network.code});
    const methods = document.querySelectorAll('.payment-method');
    methods.forEach(element => {
      if (element.getAttribute('data-method') == network.code) {
        element.classList.add('active');
      } else {
        element.classList.remove('active');
      }
    });

    this.schoolSubscripService.getPaymentFees(
       this.idSchool,
       this.totalAmount,
       this.paymentNetwork?.code
       
    ).subscribe(
      {
        next: (resp) => {
          this.fees = resp;
        },
        error: (err) => {
          this.message = err.error.message;
          const modAdd = new bootstrap.Modal('#errorDialog', {});
          modAdd.show();
        }
      }
    );

    if(!network.isMobileMoney) {
      this.phoneForm.patchValue({phone: '00000000000'});
    }
  }

  returnToSearch() {
    this.onCancelSubscription();
  }

  onChangeItem(event: any, item: SchoolSubsItemValue) {
    const isChecked = (event.target as HTMLInputElement).checked;
    if (isChecked) {
      this.selectedItems.push(item);
    } else {
      let index = this.selectedItems.findIndex(it => it.libelle === item.libelle);
      if (index >= 0) {
        this.selectedItems.splice(index, 1);
      }
    }
    this.calculateTotalAmount();
  }
}
